type Listener = () => void;

let suppressed = false;
const listeners = new Set<Listener>();

export function isOfferModalSuppressed(): boolean {
  return suppressed;
}

export function setOfferModalSuppressed(next: boolean): void {
  if (suppressed === next) return;
  suppressed = next;
  listeners.forEach((listener) => listener());
}

export function subscribeOfferModalSuppressed(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
